import { trpc } from '@/shared/lib/trpc'
import { useTabsStore } from '@/shared/stores/tabs.store'
import { useMessagesStore } from '@/shared/stores/messages.store'
import { useMetricsStore } from '@/shared/stores/metrics.store'

export function useCreateSession() {
  const addTab = useTabsStore(s => s.addTab)
  const initSession = useMessagesStore(s => s.initSession)
  const createSessionMutation = trpc.sessions.create.useMutation()

  const createSession = (options?: { spaceSlug?: string; title?: string }) => {
    createSessionMutation.mutate(options ?? {}, {
      onSuccess: (session) => {
        initSession(session.id)
        // B2 : init metrics.store avec le model issu de la réponse create (avant system:init)
        const model = (session as Record<string, unknown>).model as string | undefined
        useMetricsStore.getState().initSession(session.id, model)
        addTab({
          id: session.id,
          type: 'conversation',
          title: options?.title ?? 'Nouvelle conversation',
          sessionId: session.id,
          createdAt: Date.now(),
        })
      },
      onError: (err) => {
        console.error('Failed to create session:', err)
      },
    })
  }

  return { createSession, isLoading: createSessionMutation.isPending }
}
